import { AppProps } from "interfaces/App.interface";
import React from "react";
import CardStyle from 'styles/CarouselCard.style';

export const CarouselCardImage: React.FC<AppProps> = (props) => {
    return (
        <img
            src={props.app.image}
            alt={props.app.name}
            style={CardStyle}
            draggable={false}
        />
    );
};

export default CarouselCardImage;
